import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class ContractorDebtForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      employees: [],
    },
    data: {
      amount: "",
      verified_by_staff_id: "",
      verification_date: "",
      payment_deadline: "",
      remark: "",
      attachment: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const { popUp } = this.context;

    console.log(popUp);

    if (popUp?.edit) {
      data.amount = popUp.edit.amount;
      data.verified_by_staff_id = popUp.edit.verified_by_staff_id;
      data.verification_date = popUp.edit.verification_date;
      data.payment_deadline = popUp.edit.payment_deadline;
      data.remark = popUp.edit.remark;
    }

    await db
      .getAll(`dropdowns/staff?sectionId=1`)
      .then(({ data: { data } }) => (drp["employees"] = data));

    this.setState({ drp, data });
  };

  schema = {
    amount: Joi.number().required(),
    verified_by_staff_id: Joi.number().required(),
    verification_date: Joi.date().required(),
    payment_deadline: Joi.date().required(),
    remark: Joi.string().required(),
    attachment: Joi.allow(null).allow(""),
  };

  doSubmit = async ({ target }) => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        contractor_id: popUp.cache
          ? popUp.cache
          : popUp.edit.data.contractor_id,
        ...this.state.data,
      });

      await db
        .form("contractors/payable", target, __controls, popUp?.edit?.id)
        .then(() => {
          togglePopUp({ form: "toast" });
        })

        .catch((err) => {
          togglePopUp({
            form: "toast",
            message: err.toString(),
            type: "warning",
          });
        });
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditDebt : lbl.SaveDebt}</p>
          </div>
          <div className="form-inputs">
            {this.renderInput("amount", "مبلغ", "number")}
            {this.renderSelect(
              "verified_by_staff_id",
              "تایید کننده",
              drp["employees"]
            )}
            {this.renderInput("verification_date", "تاریخ ارزیابی", "date")}
            {this.renderInput("payment_deadline", "مهلت پرداخت", "date")}
            {this.renderInput("remark", "ملاحظه", "textarea")}
            {this.renderFile("attachment", "سند")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default ContractorDebtForm;
